// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../../../config/screen';

/* ************** MODEL CONTAINER ******************* */

export const ModelContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.crusherDashboard.maintenance.borderColor};
  border-radius: 4px;
  height: 100%;

  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 1rem;
  };
`;

export const ModelTitle = styled.div`
  padding: 1rem 1rem 0 1rem;
`;

export const ModelBackgroundContainer = styled.div<{ running?: boolean }>`
  background: ${({
    running = true,
    theme,
  }) => (running
    ? theme.color.crusherDashboard.maintenance.setup.information.modelBackgroundColor
    : theme.color.crusherDashboard.maintenance.setup.information.modelBackgroundColorOff
  )};
  border-radius: 4px;
  height: 39px;
  margin: 1rem;
`;

export const ModelContentWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  padding: 1rem;
`;

/* ************** QUANTITY CONTAINER ******************* */

export const QuantityContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.color.crusherDashboard.maintenance.borderColor};
  border-radius: 4px;
`;

export const QuantityTitle = styled.div`
  padding: 1rem 1rem 0 1rem;
`;

export const QuantityContent = styled.div`
  padding: 1rem 0.5rem 1rem 1rem;
`;

export const QuantityCardContainer = styled.div`
  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 0.625rem;
  };
`;
